import React, { FunctionComponent, ReactNode } from 'react'

import { Breakpoints, useIsBreakpointLargeAndUp } from '../useBreakpoint'
import { CarouselScrollSlider, CarouselScrollSliderProps } from './CarouselScrollSlider'
import { CarouselTransformSlider, CarouselTransformSliderProps } from './CarouselTransformSlider'
import styles from './style.module.scss'

export type CarouselBreakpointsSizes = 1 | 2 | 3 | 4 | 6

export type CarouselBreakpointsSettings = {
  [bp in Breakpoints]?: CarouselBreakpointsSizes
}
export interface CarouselProps extends CarouselBreakpointsSettings {
  children: ReactNode
  testNameSpace?: string
  onChange?: (currentIndex: number, total: number) => void
  onScroll?: (scrollLeft: number, clientWidth: number, scrollWidth: number) => void
  keyNameSpace?: string
  prevButtonAriaLabel?: string
  nextButtonAriaLabel?: string
  alwaysShowTheNextButton?: boolean
  controlContainerDom?: Element
  peek?: boolean
  equalHeightItems?: boolean
}

export interface CarouselHeaderProps {
  children: ReactNode
}

export interface CarouselFooterProps {
  children: ReactNode
}

export type CarouselComponent = FunctionComponent<CarouselProps> & {
  Header: FunctionComponent<CarouselHeaderProps>
  Content: FunctionComponent<CarouselProps>
  TransformSlider?: FunctionComponent<CarouselTransformSliderProps>
  ScrollSlider?: FunctionComponent<CarouselScrollSliderProps>
  Footer?: FunctionComponent<CarouselFooterProps>
  Controls?: FunctionComponent<CarouselProps>
}

export const CarouselContent: FunctionComponent<CarouselProps> = ({
  children,
  onChange,
  onScroll,
  prevButtonAriaLabel = '',
  nextButtonAriaLabel = '',
  alwaysShowTheNextButton = false,
  controlContainerDom,
  peek = false,
  ...otherProps
}) => {
  const isBreakpointLargeAndUp = useIsBreakpointLargeAndUp()
  return (
    <>
      {isBreakpointLargeAndUp && (
        <CarouselTransformSlider
          {...otherProps}
          onChange={onChange}
          prevButtonAriaLabel={prevButtonAriaLabel}
          nextButtonAriaLabel={nextButtonAriaLabel}
          alwaysShowTheNextButton={alwaysShowTheNextButton}
          controlContainerDom={controlContainerDom}
        >
          {children}
        </CarouselTransformSlider>
      )}
      {!isBreakpointLargeAndUp && (
        <CarouselScrollSlider {...otherProps} onScroll={onScroll} peek={peek}>
          {children}
        </CarouselScrollSlider>
      )}
    </>
  )
}

export const CarouselHeader: FunctionComponent<CarouselHeaderProps> = ({ children }) => {
  return <div className={styles.header}>{children}</div>
}

export const Carousel: CarouselComponent = ({ children }) => {
  return <div className={styles.carousel}>{children}</div>
}

export const CarouselFooter: FunctionComponent<CarouselFooterProps> = ({ children }) => {
  return <div className={styles.footer}>{children}</div>
}

export const CarouselControls: FunctionComponent<CarouselProps> = ({ children }) => {
  return <div className={styles.controls}>{children}</div>
}
Carousel.Header = CarouselHeader
Carousel.Content = CarouselContent
Carousel.TransformSlider = CarouselTransformSlider
Carousel.ScrollSlider = CarouselScrollSlider
Carousel.Footer = CarouselFooter
Carousel.Controls = CarouselControls
